import { Breadcrumb as AntBreadcrumb } from 'antd';
import classNames from 'classnames';
import './style/index';
import { jsx as _jsx } from "react/jsx-runtime";
const Breadcrumb = _ref => {
  let {
    className,
    ...restProps
  } = _ref;
  return /*#__PURE__*/_jsx(AntBreadcrumb, {
    className: classNames(className, 'zen-design-breadcrumb'),
    ...restProps
  });
};
Breadcrumb.Item = AntBreadcrumb.Item;
Breadcrumb.Separator = AntBreadcrumb.Separator;
export default AntBreadcrumb;